import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import PermissionManagement from "../components/PermissionManagement";

const PermissionPage = () => {
  return (

    <>
    <Breadcrumb title= "Permissions"/>

    <PermissionManagement/>
      
  </>
  
  )
  ;
};

export default PermissionPage;
